import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

class ASQSimpleSurveysHeader extends React.Component {
  static propTypes = {
    meta: PropTypes.object.isRequired,
    onSortChange: PropTypes.func.isRequired,
  }

  render() {
    const { t } = this.props;
    return (
      <div className='o-rtable__row'>
        <div className='o-rtable__cell o-rtable__cell--age-bank'>
          <b>{t('asqSurveys.header.asq')}</b>
        </div>
        <div className='o-rtable__cell o-rtable__cell--date'>
          <b>{t('asqSurveys.header.dateCompleted')}</b>
        </div>
        <div className='o-rtable__cell o-rtable__cell--score'>
          <b>{t('asqSurveys.header.asqScore')}</b>
        </div>
        <div className='o-rtable__cell o-rtable__cell--status'>
          <b>Status</b>
        </div>
      </div>
    );
  }
}

export default withTranslation()(ASQSimpleSurveysHeader);
